import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ModuleWithProviders, NgModule, Provider } from '@angular/core';

import { SessionService } from 'src/app/auth/session.service';
import { FormsConstructorModule } from 'src/app/forms/forms-constructor.module';
import { SharedModule } from 'src/app/shared.module';
import { ViewsModule } from 'src/app/views/views.module';
import { environment } from 'src/environments/environment';
import { LongOperationsInterceptor } from '../interceptors/long-operations/long-operations.interceptor';
import { INTERCEPTOR_CONFIG } from '../interceptors/tokens';
import { GlobalSpinnerComponent } from './global-spinner/global-spinner.component';
import { OperationInfoService } from './operation-info.service';
import { SpinnerComponent } from './spinner/spinner.component';

export const LongInterceptorProvider: Provider = {
  provide: HTTP_INTERCEPTORS,
  useClass: LongOperationsInterceptor,
  multi: true,
};

@NgModule({
  imports: [SharedModule, FormsConstructorModule, ViewsModule],
  declarations: [GlobalSpinnerComponent, SpinnerComponent],
  exports: [GlobalSpinnerComponent, SpinnerComponent],
  providers: [
    SessionService,
    OperationInfoService,
    LongInterceptorProvider,
    { provide: INTERCEPTOR_CONFIG, useValue: { apiUrl: environment.apiUrl } },
  ],
})
export class LongOperationModule {
  public static forRoot(): ModuleWithProviders<LongOperationModule> {
    return {
      ngModule: LongOperationModule,
      providers: [
        SessionService,
        OperationInfoService,
        LongInterceptorProvider,
        { provide: INTERCEPTOR_CONFIG, useValue: { apiUrl: environment.apiUrl } },
      ],
    };
  }
}
